import React, { useEffect, useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import Iconify from '../iconify/Iconify';

function CustomCompletes({ placeholder, propVal, option, childFuc, fetch, fullVal, helperText, err, req,
  cityStateStyling1 }) {

  const [selectedVal, setSelectedVal] = useState('');
  const [dropdown, setdropdown] = useState(false);
  const [localOption, setLocalOption] = useState([]);

  useEffect(() => {
    if (localOption.length > 0) setdropdown(true);
    else setdropdown(false);
    setSelectedVal(propVal);
  }, []);

  useEffect(() => {
    setLocalOption(option);
  }, [option]);

  useEffect(() => {
    console.log('propval', propVal);

    setSelectedVal(propVal);
  }, [propVal]);

  const fetchValue = (e) => {
    setdropdown(true);
    setSelectedVal(e.target.value);
    childFuc(e.target.value);
    if (e.target.value.length === 0) {
      // setSelectedVal('')
      setdropdown(false);
    }
  };

  const setValue = (e) => {
    console.log("fetch====", fetch)
    console.log("e.item====", e.item)

    if (fetch === 'state') {
      const csc = `${e.item.city} ${e.item.state}`
      setdropdown(false);
      // setSelectedVal(e.item.city);
      setSelectedVal(csc);
      childFuc(e.item.city);
      fullVal(e.item);
    } else {
      setdropdown(false);
      childFuc(e.item);
      fullVal(e.item?.state_name || e.item?.state_name || e.item || e.item?.postal);
      setSelectedVal(e.item?.state_name || e.item?.state_name || e.item || e.item?.postal);
    }
  };

  const tablebg = 'rgba(82, 130, 190, 0.08)';
  return (
    <>

      <TextField
          required={req}
        size="small"
          error={err}
          helperText={err?helperText:""}
        placeholder="State"
        sx={{
          backgroundColor: "white",
          borderRadius: "9px",
          border: '3px solid #1E74B3',
          '& .MuiInputBase-input::placeholder': {
            color: 'black',
          },
        }}

        //   label='State'
        onChange={(e) => fetchValue(e)}

        value={selectedVal}
      />

      {dropdown && (
        <div
          style={{
            height: 'fit-content',
            maxHeight: 120,
            overflowY: 'scroll',
            cursor: 'pointer',
            backgroundColor: 'white',
            padding: 2,
            position: 'absolute',
            width: '12%',
          }} >

          {localOption.map((item) => {
            return (
              <Typography
                key={fetch === 'state' ? item?.zip || item?.postal : item}
                sx={{
                  '& > img': {
                    mx: 2,
                    my: 1,
                    position: 'absolute',
                    bottom: 0,
                    zIndex: 999,
                    background: 'white',
                  },
                  '&:hover': {
                    backgroundColor: tablebg,
                  },
                }}
                onClick={() => setValue({ item })}
              >
                {fetch === 'state' ? `${item?.city} (${item?.state}) (${item?.zip || item?.postal})` : item?.state_name || item?.province_or_StateName || item?.postal || item}
              </Typography>
            );
          })}
        </div>
      )}
    </>
  );
}

export default CustomCompletes;
